import { Button, QRCode } from 'antd'
import html2canvas from 'html2canvas'
import { useRef } from 'react'
import styled from 'styled-components'

const exportAsImage = async (
  el: HTMLDivElement | null,
  imageFileName: string
) => {
  if (!el) return
  const canvas = await html2canvas(el, {
    scale: 2,
  })
  const image = canvas.toDataURL('image/png', 1.0)
  downloadImage(image, imageFileName)
}

const downloadImage = (blob: string, fileName: string) => {
  const fakeLink = window.document.createElement('a')
  fakeLink.style.display = 'none'
  fakeLink.download = fileName

  fakeLink.href = blob

  document.body.appendChild(fakeLink)
  fakeLink.click()
  document.body.removeChild(fakeLink)

  fakeLink.remove()
}

const QRContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  height: 100%;
`

type QrCodeProps = {
  value: string
}

function QrCode({ value }: QrCodeProps) {
  const qrRef = useRef<HTMLDivElement>(null)
  const buttonClick = () => {
    exportAsImage(qrRef.current, 'UserQr')
  }

  return (
    <QRContainer>
      <div ref={qrRef}>
        <QRCode size={200} value={value} />
      </div>
      <Button onClick={buttonClick}>Download QR</Button>
    </QRContainer>
  )
}

export default QrCode
